import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "exam",
  oncopy: "return false",
  onpaste: "return false"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_TestInstructions = _resolveComponent("TestInstructions");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$setup.examInfoShow && !$setup.examLoading ? (_openBlock(), _createBlock(_component_router_view, {
    key: 0,
    examInfo: $setup.examInfo,
    netState: $setup.netState,
    onFinishExam: $setup.finishExam
  }, null, 8, ["examInfo", "netState", "onFinishExam"])) : _createCommentVNode("", true), $setup.examInfoShow ? (_openBlock(), _createBlock(_component_TestInstructions, {
    key: 1,
    examInfo: $setup.examInfo,
    onStart: $setup.examStart
  }, null, 8, ["examInfo", "onStart"])) : _createCommentVNode("", true)]);
}